import { useMutation } from '@tanstack/react-query';

import { reportError } from '@/features/support/services/support.api';

export function useReportErrorMutation() {
  return useMutation({
    mutationFn: reportError,
    onError: (error) => {
      console.warn('[support] error report failed', error);
    },
  });
}
